import React from 'react';
import Paper from '@material-ui/core/Paper';
import Explanation_text from './Explanation_text';
import Typography from '@material-ui/core/Typography';

export default function Section(props){
    return(
      <Paper style={{position:'relative', marginTop:'20px', paddingBottom:(props.no_padding==true)?'0px':'20px', width:'calc(100% - 20px)', maxWidth:(props.maxWidth==undefined)?'900px':props.maxWidth, marginLeft:'10px', paddingTop:(props.no_title==true)?'2px':'10px'}}>
        <div style={{width:(props.no_padding==true)?'100%':'calc(100% - 40px)', marginLeft:(props.no_padding==true)?'0px':'20px'}}>
          {(props.no_title==true)?null:<Typography color='primary' style={{position:'relative', marginBottom:(props.no_title==true)?'0px':'20px'}}><span style={{position:'relative', top:'0px'}}>{props.icon}</span><span style={{position:'absolute', top:(props.top!=undefined)?props.top:'0px', left:(props.icon==undefined)?'10px':'40px'}}>{<Explanation_text inline text={props.title}/>}</span></Typography>}
          <div style={{marginLeft:'5px'}}>{props.children}</div>
        </div>
        {(props.action!=undefined)?<div style={{position:'absolute', top:'10px', right:'10px'}}>{props.action}</div>:null}
      </Paper>
    )
}
